/* Boat Supply Miami - Evinrude Spark Plug Guide V22 FINAL
   Data: current Niterra/NGK online Part Finder + 2024-2025 Marine Catalogue + BRP model references.
   Safety rule: an exact model is never forced into a conflicting spark-plug application.
   If the model is recognized but the available technical rows are not uniquely reconcilable,
   the guide returns a verification-required result instead of a false plug recommendation. */
(() => {
  const compact = v => String(v || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^A-Z0-9]/g,'');
  const normal = v => String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9.\-]+/g,' ').replace(/\s+/g,' ').trim();
  const variants = raw => {
    const first=compact(raw), out=[first]; let q=first;
    // V/T/H/R/B/D can precede the E designator in regional/production model numbers.
    for(let i=0;i<2;i++){
      if(q.length>1 && 'VTHRBD'.includes(q[0]) && q[1]==='E'){ q=q.slice(1); out.push(q); }
    }
    return [...new Set(out)];
  };
  const yearRangeMatch = (txt, y) => {
    if(!y) return true;
    const s=String(txt||'').trim(); if(!s || s==='-') return false;
    const nums=(s.match(/(?:19|20)\d{2}/g)||[]).map(Number);
    if(!nums.length) return false;
    if(nums.length>=2) return y>=nums[0] && y<=nums[1];
    if(/-$|onward|desde|en adelante/i.test(s)) return y>=nums[0];
    return y===nums[0];
  };
  const modelPatternMatch=(q,p)=>{
    q=compact(q); const wild=String(p||'').endsWith('*'); p=compact(String(p||'').replace(/\*$/,''));
    return wild ? q.startsWith(p) : q===p;
  };
  const familyFromModernCode = q => {
    const c=compact(q); const fm=c.match(/(AA|AB|AF|AG|AH|AJ|AK)[A-Z]?$/); const hm=c.match(/(\d{1,3})/);
    if(!fm || !hm) return null;
    const hp=Number(hm[1]); if(!hp) return null;
    return {family:fm[1],hp};
  };
  const post2012Spec = hp => {
    // Portable four-stroke families use DCPR6E. Evinrude 15 HP E-TEC applications use IZFR6N-E.
    if([3.5,4,6,9.8,10].includes(hp)) return {plug:'DCPR6E',gap:'0.9'};
    if([15,25,30,40,50,55,60,65,75,90,105,115,130,135,140,150,175,200,225,250,300].includes(hp)) return {plug:'IZFR6N-E',gap:'0.8'};
    return null;
  };

  document.querySelectorAll('[data-bsm-evinrude-guide]').forEach(root => {
    if(root.dataset.ready==='true') return; root.dataset.ready='true';
    const A=window.BSM_EVINRUDE_APPLICATIONS||[];
    const M=window.BSM_EVINRUDE_MODEL_MASTER||[];
    const input=root.querySelector('input[type="search"]');
    const tbody=root.querySelector('tbody');
    const count=root.querySelector('.bsm-controls p');
    const empty=root.querySelector('.bsm-empty');
    const isEs=(document.documentElement.lang||'').toLowerCase().startsWith('es') || root.dataset.locale==='es';
    const L={
      buy:isEs?'Ver esta bujía':'Shop this plug',
      verify:isEs?'Verificar modelo/serie':'Verify model/serial',
      recognized:isEs?'Modelo reconocido — verificación requerida':'Model recognized — verification required',
      applications:isEs?'aplicaciones':'applications', application:isEs?'aplicación':'application',
      models:isEs?'modelos':'models'
    };
    const labels=Array.from(root.querySelectorAll('thead th')).map(x=>x.textContent.trim());
    const shopUrl=p=>`https://www.boatsupplymiami.com/search?q=${encodeURIComponent(p==='B6S'?'BR6S':p)}&type=product`;
    const appText=a=>normal([a.m,a.h,a.y,a.n,a.g,a.p,(a.c||[]).join(' ')].join(' '));
    A.forEach((a,i)=>{a._i=i;a._t=appText(a);a._mc=compact(a.m);});

    const makeCell=(label,html)=>{const td=document.createElement('td');td.dataset.label=label||'';td.innerHTML=html;return td;};
    const rowForApp=(a,modelOverride)=>{
      const tr=document.createElement('tr');
      const model=modelOverride||a.m;
      tr.append(
        makeCell(labels[0], a.h!=null?`${a.h} HP`:a.m),
        makeCell(labels[1], model),
        makeCell(labels[2]||'HP', a.h==null?'—':String(a.h)),
        makeCell(labels[3], a.y||'—'),
        makeCell(labels[4], `<strong>${a.p||'—'}</strong>`),
        makeCell(labels[5], a.g||'—'),
        makeCell(labels[6], a.p?`<a class="bsm-buy" href="${shopUrl(a.p)}" rel="noopener" target="_blank">${L.buy}</a>`:'—')
      );
      return tr;
    };
    const verifyRow=(model,meta,message)=>{
      const tr=document.createElement('tr'); tr.className='bsm-verify-row';
      tr.append(
        makeCell(labels[0], meta&&meta.h!=null?`${meta.h} HP`:'Evinrude'),
        makeCell(labels[1], `<strong>${model}</strong><br><span class="bsm-verify-first">${message||L.recognized}</span>`),
        makeCell(labels[2]||'HP',meta&&meta.h!=null?String(meta.h):'—'),
        makeCell(labels[3],meta&&meta.y?String(meta.y):'—'),
        makeCell(labels[4],`<strong>${L.verify}</strong>`),
        makeCell(labels[5],'—'),
        makeCell(labels[6],`<span class="bsm-unavailable">${L.verify}</span>`)
      ); return tr;
    };
    const render=(nodes)=>{
      tbody.textContent=''; nodes.forEach(n=>tbody.appendChild(n));
      const n=nodes.length; count.textContent=`${n} ${n===1?L.application:L.applications}`; empty.hidden=n!==0;
    };
    const appRowsByHpYear=(hp,year)=> A.filter(a=>a.h!=null && Math.abs(a.h-hp)<.0001 && yearRangeMatch(a.y,year));
    const exactAppMatches=q=>{
      const vs=variants(q); const found=[];
      A.forEach(a=>{
        if(vs.includes(a._mc) || (a.c||[]).some(c=>vs.includes(compact(c)))) found.push(a);
      }); return found;
    };
    const bestUnique=(candidates)=>{
      if(!candidates.length) return null;
      const specs=new Map();
      candidates.forEach(a=>{const k=`${a.p}|${a.g}`;if(!specs.has(k)) specs.set(k,[]);specs.get(k).push(a);});
      if(specs.size===1) return [...specs.values()][0][0];
      return null;
    };
    const findMeta=q=>{
      const vs=variants(q); let matches=[];
      M.forEach(m=>{ if(vs.some(v=>modelPatternMatch(v,m.p))) matches.push(m); });
      if(!matches.length) return null;
      // Prefer exact pattern then safest confidence and latest exact year consistency.
      const rk={n:5,s:4,x:3,i:2,l:1,u:0};
      matches.sort((a,b)=>(rk[b.c]||0)-(rk[a.c]||0));
      return matches[0];
    };
    const resolveModel=q=>{
      const direct=exactAppMatches(q);
      if(direct.length){
        const unique=bestUnique(direct);
        if(unique) return {kind:'app',app:unique,meta:{h:unique.h,y:Number((unique.y.match(/\d{4}/)||[])[0])||null}};
        return {kind:'verify',meta:{h:direct[0].h,y:null}};
      }
      // The audited BRP 1968–2012 master index always takes priority. This prevents an older
      // production suffix that happens to end in AA/AB/AF/AG/AH/AJ/AK from being mistaken
      // for a post-2012 family code.
      const meta=findMeta(q);
      if(!meta){
        const modern=familyFromModernCode(q);
        if(modern){
          const spec=post2012Spec(modern.hp);
          if(spec){
            // Do not borrow the year/description from an older E-TEC row. Build a neutral
            // family result so an AA/AB/AF/AG/AH/AJ/AK model never displays a false historic year.
            const synthetic={m:`${modern.family} Model`,h:modern.hp,y:'Post-2012',n:'BRP post-2012 model family',g:spec.gap,p:spec.plug,s:'',c:[]};
            return {kind:'app',app:synthetic,meta:{h:modern.hp,y:null},modern:true};
          }
          return {kind:'verify',meta:{h:modern.hp,y:null}};
        }
        return null;
      }
      if(meta.h==null || meta.c==='u' || meta.c==='l') return {kind:'verify',meta};
      let cand=appRowsByHpYear(Number(meta.h),Number(meta.y));
      // Model code feature refinements. Only narrow when evidence exists; never force.
      const c=variants(q)[0];
      const isFicht=/E\d{2,3}F/.test(c);
      const isEtec=/E\d{2,3}D/.test(c) && Number(meta.y)>=2004;
      const isFour=/\dR?L?4/.test(c) || /4S/.test(c);
      const isJet=/J/.test(c.slice((c.match(/\d{1,3}/)||[''])[0].length+1));
      if(isFicht){ const f=cand.filter(a=>/f\.f\.i|ficht|direct injection|exact models/i.test(`${a.m} ${a.n}`)); if(f.length) cand=f; }
      if(isEtec){ const d=cand.filter(a=>/e-?tec|exact models/i.test(`${a.m} ${a.n}`)); if(d.length) cand=d; }
      if(isFour){ const f=cand.filter(a=>/4 stroke|4-stroke|four stroke|dohc|ohc/i.test(`${a.m} ${a.n}`)); if(f.length) cand=f; }
      if(isJet){ const j=cand.filter(a=>/jet/i.test(`${a.m} ${a.n}`)); if(j.length) cand=j; }
      const unique=bestUnique(cand);
      if(unique) return {kind:'app',app:unique,meta};
      return {kind:'verify',meta};
    };

    const filter=()=>{
      const raw=input.value.trim();
      if(!raw){ render(A.map(a=>rowForApp(a))); return; }
      const qn=normal(raw), qc=compact(raw);
      // Treat compact alphanumeric strings containing letters+digits as model searches first.
      if(/[A-Z]/.test(qc) && /\d/.test(qc) && qc.length>=4){
        const r=resolveModel(raw);
        if(r){
          if(r.kind==='app') render([rowForApp(r.app,qc)]);
          else render([verifyRow(qc,r.meta)]);
          return;
        }
      }
      const tokens=qn.split(' ').filter(Boolean);
      const yearToken=tokens.find(t=>/^(?:19|20)\d{2}$/.test(t));
      const hpToken=tokens.find(t=>/^\d+(?:\.\d+)?$/.test(t) && !/^(?:19|20)\d{2}$/.test(t));
      const year=yearToken?Number(yearToken):null, hp=hpToken?Number(hpToken):null;
      const textTokens=tokens.filter(t=>t!==yearToken && t!==hpToken && t!=='hp');
      const found=A.filter(a=>{
        if(hp!=null && (a.h==null || Math.abs(a.h-hp)>.0001)) return false;
        if(year!=null && !yearRangeMatch(a.y,year)) return false;
        return textTokens.every(t=>a._t.includes(t));
      });
      render(found.map(a=>rowForApp(a)));
    };
    input.addEventListener('input',filter); filter();
  });
})();
